export default __webpack_public_path__ + "d0493b9f236fa8bd8137839ddd5e1b9d.png";